const API_HOST = process.env.REACT_APP_API_HOST;

export const PUBLISH_PREVIEW_ENDPOINTS = {
  jodiDigits: "/publish-preview/jodi-digits",
};

export const fetchPublishPreviewPage = async (endpoint, payload) => {
  const response = await fetch(`${API_HOST}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("jwt"),
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  const result = await response.json();
  if (!result?.success) {
    throw new Error(result?.message || "Failed to fetch publish preview");
  }

  return result.data;
};

export const createPublishPreviewDatasource = ({
  endpoint,
  getBasePayload,
  getSearch,
  onMeta,
  onError,
}) => ({
  getRows: async (params) => {
    try {
      const pageSize = params.endRow - params.startRow;
      const page = Math.floor(params.startRow / pageSize) + 1;
      const sortModel = params.sortModel?.[0];

      const data = await fetchPublishPreviewPage(endpoint, {
        ...getBasePayload(),
        page,
        pageSize,
        search: getSearch?.() || "",
        sortField: sortModel?.colId || "",
        sortOrder: sortModel?.sort || "asc",
      });

      onMeta?.(data);
      params.successCallback(data.rows || [], data.pagination?.totalRows ?? 0);
    } catch (error) {
      console.error("Publish preview datasource error:", error);
      onError?.(error);
      params.failCallback();
    }
  },
});

/** Jodi candidates for a known open digit: `<openDigit><0..9>`. */
export const buildJodiCandidates = (openDigit) => {
  const prefix = String(openDigit);
  return Array.from({ length: 10 }, (_, i) => `${prefix}${i}`);
};

export const formatAmount = (value) =>
  value != null && value !== "" ? Number(value).toFixed(2) : "0.00";
